<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'AvContractTypeOfDataForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.typeOfData')" xs12 md12>
            <rbx-extended-textarea
              v-model="avContract.typeOfData"
              property-code="avContract.typeOfData"
              label="Art der Daten"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.affectedPersonCategories')" xs12 md12>
            <rbx-extended-textarea
              v-model="avContract.affectedPersonCategories"
              property-code="avContract.affectedPersonCategories"
              label="Kategorien betroffener Personen"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
